export default __webpack_public_path__ + "static/media/King_of_hearts.10f5dafd.svg";